import React from "react";
import { graphql } from "gatsby";
import PropTypes from "prop-types";
import { Container } from "react-bootstrap";
import classNames from "classnames";

import NavigationMenu from "./NavigationMenu";
import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";
import HeaderContent from "./HeaderContent";

import "../styles/components/Header.scss";

// Header container. Provide Header content as children of this component.
const Header = ({ location, header, layout }) => {
    const activeKey = location?.pathname?.split("/")[1];

    return [
        <NavigationMenu
            key="header-nav-menu"
            activeKey={activeKey}
            hasHeader={!!header}
            layout={layout}
        />,
        header && (
            <header className="header" key="header-main">
                {header?.heroImage && (
                    <GatsbyImageWithSVGSupport
                        image={header.heroImage}
                        className="hero-image"
                        alt={
                            header.heroImage.description ||
                            header.heroImage.title ||
                            "HomeCare"
                        }
                        loading="eager"
                        fetchPriority="high"
                    />
                )}
                {header && (
                    <div
                        className={classNames({
                            "header-overlay": header?.heroImage,
                            "mt-3": !header?.heroImage,
                        })}
                    >
                        <Container>
                            <HeaderContent header={header} />
                        </Container>
                    </div>
                )}
            </header>
        ),
    ];
};

Header.propTypes = {
    header: PropTypes.shape({
        heroImage: PropTypes.shape({ gatsbyImageData: PropTypes.object }),
    }),
    location: PropTypes.object,
    layout: PropTypes.string,
};

export const query = graphql`
    fragment HeaderData on ContentfulHeader {
        title {
            raw
        }
        copy {
            raw
        }
        className
        heroImage {
            gatsbyImageData(layout: CONSTRAINED)
            title
            description
            file {
                contentType
                url
            }
            url
        }
        buttons {
            id
            label
            url
            variant
        }
    }
`;

export default Header;
